export const buscarPorCriterio = ({ array, propiedad, criterio }) => {
  const objetoNuevo = array.find((objeto) => objeto[propiedad] === criterio);

  return objetoNuevo;
};
